
# This vuex module groups all user-settable settings.
# When the user wants to remember a certain configuration, it means remembering
# all of these toggles and variable, i.e. the full state.
module =
    namespaced: true
    state: {}
    getters: {}
    mutations: {}
    actions: {}

module.state =
    # 2-states
    show_hidden: 0
    show_by_year: 1
    show_score_own: 1
    show_score_imdb: 1
    show_score_metacritic: 0
    show_review_time: 0
    show_release_time: 0
    show_collection_time: 0
    show_year: 0
    show_genre: 0
    show_runtime: 0

    # 3-states
    show_absolute_index: 0
    show_series: 0
    show_in_collection: 1
    show_seen: 1
    show_released: 1
    layout: 0 # compact - normal - wide

    # Sorting
    sortchoice: 'votes'

    # Searching
    search_title: ''

module.mutations =
    setFilter: (state, [filter, value]) ->
        state[filter] = value

export default module
